/* eslint-disable no-param-reassign */
/* eslint-disable func-names */
import { Window } from '../../00_IMMEDIATE/Window';
import { Window_FillRateFallback } from './Window_FillRateFallback';
import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../OMT_UI/OMT_UI_SquareButton';
import { XPROMO_PLACEMENTS } from '../../Services/OMT/OMT_CrossPromo';

class Window_notEnoughLives extends Window {
  constructor(parentWindow, config) {
    super(parentWindow);

    const lifePrice = G.json.settings.buyLifePrice;
    const hasEnoughForLife = G.saveState.isEnoughToBuy(lifePrice);
    let buyLife = G.featureUnlock.outOfLives_buyLife;
    const group = new Phaser.Group(game);

    /**
     * @property openLevelPopUp       [Boolean]   Should the window show a level popup when closed?
     * @property lvlIndex             [Number]    What state is the game currently in?
     * @property levelPopUpLayerName  [String]    Should the window show a level popup when closed?
     * @type {Object}
     */
    this.config = config || {};

    if (G.BuildEnvironment.production && game.device.desktop) {
      buyLife = true; // no monetize on desktop
    }

    this.add(group);

    const windowBg = G.makeImage(0, 33, 'popup_background_2', 0.5, group);
    windowBg.width = 460;
    windowBg.height = 540;
    const livesBanner = G.makeImage(0, -205, 'gold_wheel_ribbon', 0.5, group);
    livesBanner.width = windowBg.width * 0.95;
    livesBanner.scale.y = livesBanner.scale.x;
    const heartImage = G.makeImage(0, -63, 'heart', 0.5, group);
    heartImage.scale.set(1.3);
    G.makeImage(-7, 13, 'timer_bar', 0.5, group);

    this.noMoreLivesTxt = new G.Text(0, livesBanner.y - livesBanner.height * 0.1 + 5, OMT.language.getText('No more lives!'), {
      style: 'font-white',
      fontSize: '50px',
    }, 0.5, livesBanner.width * 0.9);
    group.add(this.noMoreLivesTxt);

    this.livesNrTxt = new G.Text(G.OMTsettings.elements.Window_notEnoughLives.livesNrTxt.x, G.OMTsettings.elements.Window_notEnoughLives.livesNrTxt.y, '0', {
      style: 'font-white',
      fontSize: '40px',
    }, 0.5, 150);
    group.add(this.livesNrTxt);

    this.timerTxt = new G.TextTimer(20, 15, 0, {
      style: 'font-white',
      fontSize: '35px',
    }, 0.5, 140, 'ms');
    group.add(this.timerTxt);

    this.coinsBg = G.makeImage(0, -285, 'top-panel-coinsBg', 0.5, group);
    this.coinsTxt = new G.Text(
      G.OMTsettings.elements.Window_notEnoughLives.coinsTxt.x,
      G.OMTsettings.elements.Window_notEnoughLives.coinsTxt.y,
      OMT.language.toLocaleNumber(G.saveState.getCoins()),
      G.OMTsettings.elements.Window_notEnoughLives.coinsTxt.style,
      0.5,
      110,
    );
    group.add(this.coinsTxt);

    this.closeButton = new G.Button(210, -230, 'btn_x', function () {
      if (game.state.current !== 'World') {
        G.sb('onStateChange').dispatch('World');
      } else {
        this.notEnoughLives_closeWindow(() => {
          const crossPromoData = OMT.crossPromo.getPromoByPlacementId(XPROMO_PLACEMENTS.NO_LIVES);
          OMT.crossPromo.showCrossPromoWindow('no_lives', crossPromoData);
        });
      }
    }, this);
    
    if (!G.OMTsettings.global.jungleMatch)
      this.closeButton.scale.setTo(0.6);
    
    group.add(this.closeButton);


    // if (window.OMT.feature.isGiftingSupported()) {
    //   const onFriendClick = () => {
    //     if (game.state.current === 'Game') {
    //       G.sb('onStateChange').dispatch('World', undefined, () => {
    //         G.sb('openLifeTransactionsMenu').dispatch();
    //       });
    //     } else {
    //       this.notEnoughLives_closeWindow();
    //       G.sb('openLifeTransactionsMenu').dispatch();
    //     }
    //   };
    //   this.askFriendsButton = new OMT_UI_SquareButton(0, 210, {
    //     button: {
    //       tint: BUTTONCOLOURS.blue,
    //       dimensions: {
    //         width: 309,
    //         height: 100,
    //       },
    //       extraDetail: false,
    //     },
    //     text: {
    //       string: OMT.language.getText('Ask Friend!'),
    //       textStyle: 'font-white',
    //     },
    //     options: {
    //       clickFunction: {
    //         onClick: onFriendClick.bind(this),
    //       },
    //     },
    //   });
    //   group.add(this.askFriendsButton);
    // }

    this.notEnoughLives_createBuyLifeBtn(hasEnoughForLife, lifePrice, group);
    this.notEnoughLives_createEarnLifeBtn(group);
    if (buyLife) {
      this.notEnoughLives_setBuyLifeBtnVisible(true);
    } else {
      this.notEnoughLives_setEarnLifeBtnVisible(true);
    }

    G.Utils.cleanUpOnDestroy(this,
      G.sb('onLifeTimerUpdate').add(this.timerTxt.setSecLeft, this.timerTxt));

    G.Utils.cleanUpOnDestroy(this,
      G.saveState.signals.onLifeAmountChanged.add((amount) => {
        if (amount > 0) {
        // window was triggering twice
        // this.notEnoughLives_onLifeAdded();
        }
      }, this));
  }

  notEnoughLives_createBuyLifeBtn(hasEnoughForLife, lifePrice, parent) {
    const onClick = () => {
      if (hasEnoughForLife) {
        DDNA.transactionHelper.trackRewards([['life', 1]], [], {
          transactionType: 'COIN_PURCHASE',
          tActionType: 'LIFE_PURCHASE',
          tGameArea: game.state.getCurrentState().key === 'Game' ? 'LEVEL' : 'MAP',
          tCoinsUsed: lifePrice,
        });

        OMT.transactionTracking.logInventoryTransactionBegin();
        OMT.transactionTracking.addInventoryChange('coins', 0, -lifePrice);
        OMT.transactionTracking.logInventoryTransactionEnd();

        G.saveState.changeCoins(-lifePrice);
        G.saveState.addLife();
        this.notEnoughLives_checkTriggerPopUpConfig();
        this.notEnoughLives_closeWindow();
      } else if (G.IAP) {
        // coin shop
        this.closeWindow();
        G.Helpers.pushOutOfCoinsPopUp(false, {
          event: OMT.platformTracking.Events.OpenShopLives,
        });
        G.sb('pushWindow').dispatch(['notEnoughLives']);
      }
    };
    this.buyLifeButton = new OMT_UI_SquareButton(0, 105, {
      button: {
        tint: BUTTONCOLOURS.green,
        dimensions: {
          width: 309,
          height: 100,
        },
        isEnabled: (hasEnoughForLife || (G.IAP && !hasEnoughForLife)),
      },
      options: {
        clickFunction: {
          onClick: onClick.bind(this),
        },
      },
    });

    parent.add(this.buyLifeButton);

    this.buyLifeButton_text = new G.Text(-125, 110, OMT.language.getText('Buy a life'), {
      style: 'font-white',
      fontSize: '40px',
      align: 'center',
    }, 0, 135, 80, true);
    this.buyLifeButton_text.anchor.setTo(0, 0.5);
    parent.add(this.buyLifeButton_text);

    this.buyLifeButton_coin = G.makeImage(33, 110, 'currency', 0.5, parent);
    this.buyLifeButton_coin.scale.setTo(0.9);

    this.buyLifeButton_coinTxt = new G.Text(135, 110, lifePrice.toString(), G.OMTsettings.elements.Window_notEnoughLives.buyLifeButton_coinTxt.style, 0, 200);
    this.buyLifeButton_coinTxt.anchor.setTo(1, 0.5);
    parent.add(this.buyLifeButton_coinTxt);

    this.notEnoughLives_setBuyLifeBtnVisible(false);
  }

  notEnoughLives_onLifeAdded() {
    this.closeWindow();
    this.notEnoughLives_checkTriggerPopUpConfig();
  }

  notEnoughLives_checkTriggerPopUpConfig() {
    this.notEnoughLives_closeWindow();
    if (this.config.openLevelPopUp) {
      G.sb('pushWindow').dispatch(
        ['level', this.config.lvlIndex],
        false,
        // eslint-disable-next-line no-nested-ternary
        game.state.current === 'World' ? G.WindowMgr.LayerNames.AboveHighScorePanel : this.config.levelPopUpLayerName ? this.config.levelPopUpLayerName : G.WindowMgr.LayerNames.Base,
      );
    }
  }

  notEnoughLives_setBuyLifeBtnVisible(visible) {
    this.buyLifeButton.visible = visible;
    this.buyLifeButton_text.visible = visible;
    this.buyLifeButton_coin.visible = visible;
    this.buyLifeButton_coinTxt.visible = visible;
  }

  notEnoughLives_setEarnLifeBtnVisible(visible) {
    this.earnLifeButton.visible = visible;
  }

  // TODO: is this ever used? If not we need to remove it and test
  notEnoughLives_createEarnLifeBtn(parent) {
    const onClick = () => {
      this.earnLifeButton.inputEnabled = false;

      sdkHandler.trigger('rewardedAd',{     
        callback: (success) => { 
            if (success) {this.notEnoughLives_adSuccess();} 
            else {/* 'no more videos screen */ 
            new Window_FillRateFallback(undefined, {
                      placement: G.BuildEnvironment.adPlacements.addLife,
                      callback: this.notEnoughLives_adSuccess,
                      context: this,
                    });
                    this.notEnoughLives_setBuyLifeBtnVisible(true);
                    this.notEnoughLives_setEarnLifeBtnVisible(false);
          }
        } 
    },this);
      

      // OMT.ads.showAd(
      //   G.BuildEnvironment.adPlacements.addLife,
      //   this.notEnoughLives_adSuccess.bind(this),
      //   () => {
      //     if (!G.IAP) { // no IAPS dont use ad fallbacks
      //       // eslint-disable-next-line no-new
      //       new Window_FillRateFallback(undefined, {
      //         placement: G.BuildEnvironment.adPlacements.addLife,
      //         callback: this.notEnoughLives_adSuccess,
      //         context: this,
      //       });

      //       this.notEnoughLives_setBuyLifeBtnVisible(true);
      //       this.notEnoughLives_setEarnLifeBtnVisible(false);
      //     } else { // open ad fallback
      //       OMT.ads.showAdFallback(this.notEnoughLives_adSuccess.bind(this));
      //     }
      //   },
      // );
    };
    const img = G.makeImage(95, 103, 'btn-movie-icon', 0.5, null);
    this.earnLifeButton = new OMT_UI_SquareButton(0, 105, {
      button: {
        tint: BUTTONCOLOURS.purple,
        dimensions: {
          width: 309,
          height: 100,
        },
      },
      text: {
        string: OMT.language.getText('Earn a life'),
        textStyle: { style: 'font-white', fontSize: 40 },
        icon: {
          image: img,
          align: 'right',
          offset: {
            x: -img.width / 2,
          },
        },
        offset: {
          x: -img.width / 4,
        },
      },
      options: {
        clickFunction: {
          onClick: onClick.bind(this),
        },
      },
    });
    parent.add(this.earnLifeButton);

    this.notEnoughLives_setEarnLifeBtnVisible(false);
  }

  notEnoughLives_adSuccess() {
    if (game.state.current === 'World') {
      this.notEnoughLives_addLife();
    } else {
      G.saveState.addLife(G.json.settings.livesForAd);
      this.notEnoughLives_closeWindow();
    }

    this.notEnoughLives_checkTriggerPopUpConfig();
  }

  notEnoughLives_addLife() {
    let batch;

    if (game.state.current === 'World') {
      batch = this.state.uiTargetParticles.createDividedBatch(
        game.world.bounds.x + this.worldPosition.x,
        this.worldPosition.y,
        'heart',
        this.state.panel.lifeUI.lifeIcon,
        1,
        1,
      );

      batch.addOnPartFinish(() => {
        G.saveState.addLife(1);
      });
      batch.start();
    } else {
      G.saveState.addLife(1);
    }

    this.notEnoughLives_closeWindow();
  }

  notEnoughLives_closeWindow(callback = null) {
    G.sb('onLifeTimerUpdate').remove(this.timerTxt.setSecLeft, this.timerTxt);
    this.closeWindow(callback);
  }
}

// create global references
if (!window.Windows) window.Windows = {};
Windows.notEnoughLives = Window_notEnoughLives;
